<div class="main-container">
    <!-- <div class="info-container" [ngClass]="{'hidden': false}">
        <div class="logo-container">
            <h1>Logo</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
            <p>Provident quaerat corrupti quod nostrum veniam beatae.</p>
        </div>
        <div class="useful-links-container">
            <h2>Useful Links</h2>
            <ul>
                <li>Some link</li>
                <li>Some link</li>
                <li>Some link</li>
                <li>Some link</li>
                <li>Some link</li>
                <li>Some link</li>
                <li>Some link</li>
            </ul>
        </div>
        <div class="contract-container">
            <h2>Contract Us</h2>
            <p>Some where</p>
            <p>Some where, Some where </p>
            <p>Some where, Some where 00000</p>
            <p>Phone: 0 0000 0000</p>
            <p>Fax: 0 0000 0000-0</p>
            <p>Hotline: 0 0000 0000</p>
            <p>Email: email@email.co.th</p>
        </div>
        <div class="others-container">
            <h2>Others</h2>
            <p>Follow us on Social Media</p>
            <ul>
                <li>Some social media</li>
                <li>Some social media</li>
            </ul>
        </div>
    </div> -->
    <div class="version">
        <p>Version 0.1.5</p>
    </div>
</div>